import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { createCustomLayout } from 'PreviewActions/customLayoutActions';
import styled from 'styled-components';
import { addNewIcon } from 'Shared/assets/images/';

const AddNewLayoutBackground = styled.div`
  position: absolute;
  width: 340px
  left: calc(50% - 170px);
  top: calc(50% - 125px);
  padding: 60px;
  text-align: center;
  background: rgba(200,200,200, 0.2);
  border-radius: 6px;
`;

const AddNewIcon = styled.span`
  display: block;
  font-size: 50px;
`;

const AddNewMessage = styled.span`
  display: block;
  margin-top: 16px;
  opacity: 0.6;
`;

const AddNewSubMessage = styled.span`
  display: block;
  margin-top: 6px;
  opacity: 0.6;
  font-size: 85%;
`;

class AddNewLayout extends PureComponent {
  render() {
    const { createCustomLayout } = this.props;
    return (
      <AddNewLayoutBackground onClick={createCustomLayout}>
        <AddNewIcon>
          <img
            src={addNewIcon}
            alt="add new layout"
            style={{
              width: '60px',
              height: 'auto',
              display: 'block',
              margin: 'auto',
            }}
          />
        </AddNewIcon>
        <AddNewMessage>Create a new layout</AddNewMessage>
        <AddNewSubMessage>Click here to create a new custom layout</AddNewSubMessage>
      </AddNewLayoutBackground>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  createCustomLayout: () =>
    dispatch(createCustomLayout()),
});


export default connect(mapStateToProps, mapDispatchToProps)(AddNewLayout);



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/components/AddNewLayout/AddNewLayout.jsx